import { Path, PathLike } from '@move-frontend/contentful-routes';
import { getBaseUrl } from './getBaseUrl';

export function getAbsoluteUrl(path: PathLike) {
	const baseUrl = getBaseUrl();
	const baseUrlWithoutTrailingSlash = baseUrl.replace(/\/$/, '');

	return baseUrlWithoutTrailingSlash + Path.from(path).toString();
}
